module.exports = __webpack_public_path__ + "img/project_CAD2Path.56ec5af6.png";